// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"9a43e061","161":"fad443fb","477":"cb40fd23","744":"cfb7f845","801":"8b598ee5","980":"c7308fc4"}[chunkId] + ".chunk.js";
};